
const sort = ["serious", "accident", "medical", "life", "pension", "inherited"];

/*计算保障充实度 => Promise */
let coordinateCoordinates = [];
const riskIndex = ({ shouldGuaranteed, guaranteeds }) => {
    coordinateCoordinates = [];
    const seriesdata = [
        {
            value: sort.map(item => shouldGuaranteed[item] || 0),
            name: "应有保障",
        },
        {
            value: sort.map(item => guaranteeds[item] || 0),
            name: "已有保障",
        }
    ]
    const seriesdataRis = seriesdata.map((item, i) => {
        if (item.name == '已有保障') {
            const shouldValue = seriesdata[0].value[i]
            return {
                ...item,
                //当已有保障大于应有保障，取应有保障
                value: item.value.map(item => item > shouldValue ? shouldValue : item)
            }
        }
        return item
    })

    const maxnum = seriesdata[0].value;
    const radius = 110,
        // 指标的个数，即维度的个数
        total = sort.length,
        rangeMin = Math.max(...maxnum) / -5 * 2,
        rangeMax = Math.max(...maxnum),
        arc = 2 * Math.PI;
    // 每项指标所在的角度
    const onePiece = arc / total;

    let areaData = areasData(
        seriesdataRis,
        radius,
        total,
        rangeMax,
        rangeMin,
        onePiece
    );

    sort.forEach((key, i) => {
        let s = i + 1;
        if (i == sort.length - 1) {
            s = 0;
        }
        //计算重合部分的坐标点
        segmentsIntr(
            areaData[0].points[i],
            areaData[0].points[s],
            areaData[1].points[i],
            areaData[1].points[s]
        );
    });
    //通过面积计算百分比
    let area1 = acreage(coordinateCoordinates);
    let area2 = acreage(areaData[0].points);
    //如果已有的面积为0 通过值比较
    if (area1 == 0) {
        const duedata = seriesdata[0].value;
        let sumhave = [];
        seriesdata[1].value.forEach((key, i) => {
            if (key > duedata[i]) {
                sumhave.push(duedata[i])
            } else {
                sumhave.push(key)
            }
        })
        area1 = sum(sumhave);
        area2 = sum(duedata);
    }

    const areaNumber = Math.ceil((area1 / area2) * 100);

    return areaNumber <= 100 ? areaNumber : 100
}

//计算雷达图的坐标
const areasData = (seriesdata, radius, total, rangeMax, rangeMin, onePiece,) => {
    // 便于单元测试
    // 计算雷达图表的坐标
    let values = seriesdata;
    let areaData = [];
    values.forEach((key, i) => {
        let value = values[i].value,
            area = "",
            points = [];
        for (let k = 0; k < total; k++) {
            let r = (-radius * (value[k] - (value[k] == 0 || value[k] == 1 ? 0 : rangeMin))) / (rangeMax - rangeMin);
            let x = r * Math.sin(-k * (onePiece)),
                y = r * Math.cos(-k * (onePiece));
            area += x + "," + y + " ";
            points.push({
                x: x,
                y: y
            });
        }
        areaData.push({
            polygon: area,
            points: points
        });
    });
    return areaData;
}

//计算面积
const acreage = (acre) => {
    //计算区域面积
    let num1 = 0;
    let num2 = 0;
    acre.forEach((key, i) => {
        let s = i + 1;
        if (i == acre.length - 1) {
            s = 0;
        }
        num1 += acre[i].x * acre[s].y;
        num2 += acre[i].y * acre[s].x;
    });
    return Math.abs((parseInt(num1) - parseInt(num2)) / 2);
}

//计算焦点坐标
const segmentsIntr = (a, b, c, d) => {
    /** 1 解线性方程组, 求线段交点. **/
    // 如果分母为0 则平行或共线, 不相交 把距离原点最近的坐标添加值数组

    var denominator = (b.y - a.y) * (d.x - c.x) - (a.x - b.x) * (c.y - d.y);
    if (denominator == 0) {
        if (Math.abs(a.y) <= Math.abs(c.y) && Math.abs(a.x) <= Math.abs(c.x)) {

            coordinateCoordinates.push({
                x: a.x,
                y: a.y
            });
        } else {
            coordinateCoordinates.push({
                x: c.x,
                y: c.y
            });
        }
        return false;
    }

    if (Math.abs(a.y) <= Math.abs(c.y) && Math.abs(a.x) <= Math.abs(c.x)) {
        coordinateCoordinates.push({
            x: a.x,
            y: a.y
        });
    } else {
        coordinateCoordinates.push({
            x: c.x,
            y: c.y
        });
    }

    // 线段所在直线的交点坐标 (x , y)
    var x =
        ((b.x - a.x) * (d.x - c.x) * (c.y - a.y) +
            (b.y - a.y) * (d.x - c.x) * a.x -
            (d.y - c.y) * (b.x - a.x) * c.x) /
        denominator;
    var y = -(
        (b.y - a.y) * (d.y - c.y) * (c.x - a.x) +
        (b.x - a.x) * (d.y - c.y) * a.y -
        (d.x - c.x) * (b.y - a.y) * c.y
    ) / denominator;

    /** 2 判断交点是否在两条线段上 **/

    if (
        // 交点在线段1上
        (x - a.x) * (x - b.x) <= 0 &&
        (y - a.y) * (y - b.y) <= 0 &&
        // 且交点也在线段2上
        (x - c.x) * (x - d.x) <= 0 &&
        (y - c.y) * (y - d.y) <= 0
    ) {
        //焦点在线端处取a.x a.y
        if (y == Math.abs(c.y) || x == Math.abs(c.x) || y == Math.abs(d.y) || x == Math.abs(d.x)) {
            return
        }
        // 返回交点p
        coordinateCoordinates.push({
            x: x,
            y: y
        });

    }
}

const sum = arr => arr.reduce((acc, val) => acc + val, 0);

export default riskIndex
